import React, { useEffect, useState } from 'react';
import { useScrollReveal } from './useScrollReveal';

interface AnimatedCounterProps {
  end: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
  className?: string;
  label: string;
  description?: string;
}

const AnimatedCounter: React.FC<AnimatedCounterProps> = ({
  end, suffix = '', prefix = '', duration = 2000, className = '', label, description,
}) => {
  const { ref, isVisible } = useScrollReveal(0.3);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    const startTime = performance.now();
    const animate = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * end));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [isVisible, end, duration]);

  return (
    <div ref={ref} className="text-center">
      <div className={`text-3xl sm:text-4xl font-display font-bold text-primary ${className}`}>
        {prefix}{count}{suffix}
      </div>
      <div className="font-semibold text-foreground mt-1 text-sm">{label}</div>
      {description && <div className="text-xs text-muted-foreground mt-0.5">{description}</div>}
    </div>
  );
};

export default AnimatedCounter;
